import React, { useEffect, useState } from "react";
import Carousel from "react-material-ui-carousel";
import {
  Container,
  Typography,
  Box,
  Grid,
  Button,
  Card,
  CardMedia,
  Stack,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import CategoryCard, { CategoryCardProps } from "./CategoryCard";
import LeopardDress from "../../Components/Pictures/LeopardDress";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import ShareStockLogo from "../../Components/Pictures/ShareStockLogo";


// Statically importing until i set up a bucket in azure
const kidsImage = require('../../assets/images/kids.png');
const headerImage = require('../../assets/images/headerImage.png');
const communityImage = require('../../assets/images/communityImage.png');
const buyImage = require('../../assets/images/buy_image.jpg');
const sellImage = require('../../assets/images/sell_graphic.jpg');
const shareImage = require('../../assets/images/share_graphic.jpg');
const sustainableImage = require('../../assets/images/sustainable_graphic.jpg');
const landingPageIcon1 = require('../../assets/images/landingPageIcon1.png');
const landingPageIcon2 = require('../../assets/images/landingPageIcon2.png');
// const joinOurCommunity = require('../../assets/images/contactUs.png');
const lifestyleImage = require('../../assets/images/lifestyle.png');
const menswearImage = require('../../assets/images/menswear.png');
const carousel1 = require('../../assets/images/carousel1.png');
const carousel2 = require('../../assets/images/carousel2.png');
const carousel3 = require('../../assets/images/carousel3.png');
const womenswearImage = require('../../assets/images/womenswear.png');
// const three_testimonials = require('../../assets/images/three_testimonials.png');
// const testimonial1 = require('../../assets/images/testimonial1.png');
// const testimonial2 = require('../../assets/images/testimonial2.png');
// const testimonial3 = require('../../assets/images/testimonial3.png');

const communityText =`
Join the ShareStock community of independent brands. Publish your products through the ShareStock sales channel on Shopify, reach shoppers across the country, and keep every customer relationship on your own store.
`;

const carouselItems = [carousel1, carousel2, carousel3];

const categoryItems: Array<CategoryCardProps> = [
  {
    src: womenswearImage,
    alt: "womenswear",
    cardTitle: "Womenswear",
  },
  {
    src: menswearImage,
    alt: "menswear",
    cardTitle: "Menswear",
  },
  {
    src: lifestyleImage,
    alt: "lifestyle",
    cardTitle: "Lifestyle",
  },
  {
    src: kidsImage,
    alt: "kids",
    cardTitle: "Kids",
  },
];

// Helper to decrypt the token
const decodeToken = (token: string) => {
  try {
    const decodedToken = jwtDecode(token);
    return decodedToken;
  } catch (error) {
    console.error('Invalid token:', error);
    return null;
  }
};


const LandingPage: React.FC = () => {
  const [userIsLoggedIn, setUserIsLoggedIn] = useState<boolean>(false);

  useEffect(() => {
    // Get the token from localStorage
    const encryptedToken = Cookies.get("authToken");
    if (encryptedToken) {
      // Decrypt the token to get user data
      const userData = decodeToken(encryptedToken) as {userName: string, userId: string, companyId: string, companyName: string};
      if (userData?.userName && userData.userId && userData.companyId) {
        setUserIsLoggedIn(true);
      }
    }
  }, []);


  return (
    <Container maxWidth={false}>
      <Container maxWidth='xl' disableGutters sx={{background: "white", px:10, py:5, gap: 5, borderRadius: "10px 10px 0 0"}}>
        {userIsLoggedIn ? (
          <>

            {/* Carousel */}
            <Container maxWidth='lg'>
              <Carousel>
                {carouselItems.map((item, index) => (
                  <Card key={`carousel-${index}`}>
                    <CardMedia component="img" image={item} />
                  </Card>
                ))}
              </Carousel>
            </Container>

            {/* Shopping Categories */}
            <Container maxWidth="lg" sx={{ my: 4 }}>
              <Grid container spacing={4}>
                {categoryItems.map((item, index) =>
                  <CategoryCard key={`categoryCard-${index}`} src={item.src} alt={item.alt} cardTitle={item.cardTitle} />
                )}
              </Grid>
            </Container>
          </>
        ) : (
          <Container maxWidth='xl' sx={{paddingLeft: 0, paddingRight: 0}}>
              <Box
                sx={{
                  position: "relative",
                  width: "100%",
                  mt: -3,
                  padding: 0
                }}
              >
                <img
                  src={headerImage}
                  alt="Example"
                  style={{ width: "100%", display: "block", borderRadius: 8 }}
                />
                <Box
                  sx={{
                    position: "absolute",
                    top: "55%",
                    left: "32%",
                    transform: "translate(-50%, -50%)",
                    color: "black",
                    maxWidth: "420px",
                    width: "100%"
                  }}
                  alignItems={"start"}
                >
                    <Typography
                      variant="h2"
                      color={"black"}
                      align="left"
                      gutterBottom
                      fontWeight={400}
                      fontSize={"3rem"}
                    >
                      Share. Sell. Discover.
                    </Typography>
                    <Typography align="left" variant="subtitle1" color={"black"} paragraph fontSize={"20px"} mb={6}>
                      ShareStock is a Shopify sales channel for independent brands: publish products from your Shopify store, reach shoppers across the country on our marketplace, and complete every sale on your own Shopify Checkout.
                    </Typography>
                    <Box display="flex" gap={2}>
                      <Button variant="contained" color="primary" href="/contact">
                        Get More Info
                      </Button>
                      <Button variant="contained" color="secondary" href="/signup">
                        Sign Up
                      </Button>
                    </Box>
                </Box>
              </Box>
          </Container>

        )}
        </Container>

      <Container maxWidth='xl' disableGutters sx={{background: "#FFD54F", p: 10, gap: 5, borderRadius: "0 0 0 0"}}>
          <Grid container spacing={0} rowGap={12}>
            {/* Share Row */}
            <Grid item xs={12} md={6} alignItems={"center"} display={"flex"} p={3} justifyContent={"center"}>
              <Stack direction={"row"} gap={1} alignItems={"center"} display={"flex"}>
                <Box maxWidth={200} alignItems={"center"} display={"flex"}>
                  <img
                    src={landingPageIcon1}
                    alt="Share"
                    style={{ width: "100%" }}
                  />
                </Box>
                <Typography variant="h1">Share</Typography>
              </Stack>
            </Grid>
            <Grid item xs={12} md={6} alignItems="center" display="flex">
              <Box alignItems="center" display="flex" flexDirection="column">
                <Typography align="left" variant="body1" paragraph>
                  Reaching new customers is hard. As an independent brand, you've invested in products you believe in — now you need shoppers to find them.
                </Typography>

                <Typography align="left" variant="body1" paragraph>
                  Even great products can go unseen when they live only on a single storefront.
                </Typography>

                <Typography align="left" variant="body1" paragraph>
                  <Typography component="span" fontWeight="bold">ShareStock</Typography> is here to help…we've created an online marketplace where
                  independent brands share their catalogs with shoppers nationwide.
                </Typography>
              </Box>
            </Grid>
            {/* End of Share Row */}
            {/* Sell Row */}
            <Grid item xs={12} md={6} alignItems="center" display="flex">
              <Box alignItems="center" display="flex" flexDirection="column">
                <Typography align="left" variant="body1" paragraph>
                  When you're ready to <Typography component="span" fontWeight="bold">SELL</Typography> through a wider audience, you simply publish your products to the <Typography component="span" fontWeight="bold">ShareStock</Typography> sales channel from inside Shopify. You stay in control — pricing, inventory, and fulfillment all remain on your store.
                </Typography>

                <Typography align="left" variant="body1" paragraph>
                We then surface your listings on <Typography component="span" fontWeight="bold">mysharestock.org</Typography>, where <Typography component="span" fontWeight="bold">shoppers</Typography> looking for independent brands discover and buy directly through your Shopify Checkout.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6} alignItems={"center"} display={"flex"} p={3} justifyContent={"center"}>
              <Stack direction={"row"} gap={1} alignItems={"center"} display={"flex"}>
                <Box maxWidth={200} alignItems={"center"} display={"flex"}>
                  <img
                    src={landingPageIcon2}
                    alt="Sell"
                    style={{ width: "100%" }}
                  />
                </Box>
                <Typography variant="h1">Sell</Typography>
              </Stack>
            </Grid>
            {/* End of Sell Row */}


            {/* Discover Row */}
            <Grid item xs={12} md={6}alignItems={"center"} display={"flex"} p={3} justifyContent={"center"}>
              <Stack direction={"row"} gap={1} alignItems={"center"} display={"flex"}>
                <Box maxWidth={200} alignItems={"center"} display={"flex"}>
                  <img
                    src={communityImage}
                    alt="Discover"
                    style={{ width: "100%" }}
                  />
                </Box>
                <Typography variant="h1">Discover</Typography>
              </Stack>
            </Grid>
            <Grid item xs={12} md={6} alignItems="center" display="flex">
              <Box alignItems="center" display="flex" flexDirection="column">
                <Typography align="left" variant="body1" paragraph>
                  Shoppers are looking for something more than the same big-box catalog. On <Typography component="span" fontWeight="bold">ShareStock</Typography>, every product comes from an <Typography component="span" fontWeight="bold">independent brand</Typography> running its own Shopify store.
                </Typography>
                <Typography align="left" variant="body1" paragraph>
                  Browse <Typography component="span" fontWeight="bold">curated listings</Typography> from brands across the country, buy through each brand's secure Shopify Checkout, and support the small businesses behind every product with <Typography component="span" fontWeight="bold">ShareStock</Typography>.
                </Typography>
              </Box>
            </Grid>



            {/* Join our community */}
            {!userIsLoggedIn && (
              <>

                <Grid item xs={12} md={7} alignItems={"center"} display={"flex"}>

                <Stack direction={"column"} gap={3}>

                <Typography align="left" variant="h4" whiteSpace={"pre-wrap"}>Join our community of brands.</Typography>
                  <Typography align="left" variant="body1" whiteSpace={"pre-wrap"} paragraph>
                    {communityText}
                  </Typography>
                  <Box display="flex" gap={2}>
                    <Button variant="contained" color="primary" href="/contact">
                      Get More Info
                    </Button>
                    <Button variant="contained" color="secondary" href="/signup">
                      Sign Up
                    </Button>
                  </Box>
                </Stack>
              </Grid>
              <Grid item xs={12} md={5} alignItems={"center"} display={"flex"} pl={3} justifyContent={"center"}>
                {/* <Box
                  component="img"
                  src={joinOurCommunity}
                  alt="Example Image"
                  sx={{
                    width: "100%", // Set width
                    maxWidth: "100%",
                    height: "auto", // Maintain aspect ratio
                  }}
                /> */}
                <ShareStockLogo size={400} />
              </Grid>
              </>
            )}



            {/* End of join our community */}

            <Grid item xs={12} alignItems={"center"} display={"flex"} p={0} justifyContent={"center"}>
              <Box
                sx={{
                  position: "relative",
                  width: "100%",
                  paddingTop: "56.25%", // 16:9 Aspect Ratio
                }}
              >
                <iframe
                  src={"https://www.youtube.com/embed/fHbGXtHHq-0?si=XS9aD3YdddAsocrm"}
                  title="YouTube Video"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    border: "none",
                  }}
                />
              </Box>
            </Grid>

            {/* End of Discover Row */}


            {/* What we offer */}
            <Grid item xs={12} md={8} alignItems={"flex-start"} display={"flex"} flexDirection={"column"}>
              <Typography variant="h4" gutterBottom>
                What We Offer
              </Typography>
                <Typography align="left" variant="body1" paragraph>
                  <Typography component="span" fontWeight="bold">ShareStock</Typography> gives independent brands a <Typography component="span" fontWeight="bold">BIG new audience</Typography> for the products they already sell on their own Shopify stores.
                </Typography>
                <Typography align="left" variant="body1" paragraph>
                  <Typography component="span" fontWeight="bold">EFFORTLESS</Typography> expansion into a national marketplace, without giving up ownership of your store, your checkout, or your customer relationship.
                </Typography>
              <List sx={{ pl: 2 }}>
                <ListItem sx={{ display: "list-item", listStyleType: "disc" }}>
                  <ListItemText primary="Reach shoppers who are actively looking for independent brands" />
                </ListItem>
                <ListItem sx={{ display: "list-item", listStyleType: "disc" }}>
                  <ListItemText primary="Keep every sale on your own Shopify Checkout" />
                </ListItem>
                <ListItem sx={{ display: "list-item", listStyleType: "disc" }}>
                  <ListItemText primary="Control exactly which products appear — publish and unpublish from Shopify at any time" />
                </ListItem>
              </List>
              <Typography variant="body1" sx={{ mt: 2 }}>
                Building the customer base that keeps coming back to <Typography component="span" fontWeight="bold">YOU!</Typography>
              </Typography>
            </Grid>
            <Grid item xs={12} md={4} alignItems={"center"} display={"flex"} justifyContent={"center"}>
                <Box maxWidth={200} alignItems={"center"} display={"flex"}>
                  <LeopardDress size={450}/>
                </Box>
            </Grid>

            {/* End of what we offer */}


            {/* Four boxes  */}
            <Box display={"flex"} justifyContent={"space-between"} width={"100%"}>
                <Box alignItems={"flex-start"} display={"flex"} flexDirection={"column"} maxWidth={"220px"}>

                  <Box
                component="img"
                src={shareImage}
                alt="Example Image"
                mb={4}
                sx={{
                  width: "100%", // Set width
                  maxWidth: "100%",
                  height: "auto", // Maintain aspect ratio
                  border: "2px solid black", // Add border
                  borderRadius: "8px", // Optional: rounded corners
                }}
              />
              <Typography variant="h5" fontWeight={"bold"} gutterBottom>
                SHARE
              </Typography>
              <Typography variant="body1" gutterBottom paragraph align="left">
                SHARE your catalog with a community of shoppers across the country looking for products from independent brands.
              </Typography>
              </Box>
              <Box alignItems={"flex-start"} display={"flex"} flexDirection={"column"} maxWidth={"220px"}>
              <Box
                component="img"
                src={sellImage}
                alt="Example Image"
                mb={4}
                sx={{
                  width: "100%", // Set width
                  maxWidth: "100%",
                  height: "auto", // Maintain aspect ratio
                  border: "2px solid black", // Add border
                  borderRadius: "8px", // Optional: rounded corners
                }}
              />
              <Typography variant="h5" fontWeight={"bold"} gutterBottom>
                SELL
              </Typography>
              <Typography variant="body1" gutterBottom paragraph align="left">
                SELL to new customers through the ShareStock marketplace while every order still flows through your own Shopify Checkout.
              </Typography>
            </Box>

            <Box alignItems={"flex-start"} display={"flex"} flexDirection={"column"} maxWidth={"220px"}>
              <Box
                component="img"
                src={buyImage}
                alt="Example Image"
                mb={4}
                sx={{
                  width: "100%", // Set width
                  maxWidth: "100%",
                  height: "auto", // Maintain aspect ratio
                  border: "2px solid black", // Add border
                  borderRadius: "8px", // Optional: rounded corners
                }}
              />
              <Typography variant="h5" fontWeight={"bold"} gutterBottom>
                DISCOVER
              </Typography>
              <Typography variant="body1" gutterBottom paragraph align="left">
                DISCOVER products from independent brands you'd love — curated in one marketplace, delivered directly from the brand that made them.
              </Typography>
            </Box>

            <Box alignItems={"flex-start"} display={"flex"} flexDirection={"column"} maxWidth={"220px"}>
              <Box
                component="img"
                src={sustainableImage}
                alt="Example Image"
                mb={4}
                sx={{
                  width: "100%", // Set width
                  maxWidth: "100%",
                  height: "auto", // Maintain aspect ratio
                  border: "2px solid black", // Add border
                  borderRadius: "8px", // Optional: rounded corners
                }}
              />
              <Typography variant="h5" fontWeight={"bold"} gutterBottom>
                SUSTAINABLE
              </Typography>
              <Typography variant="body1" gutterBottom paragraph align="left">
                Help every product find its home. A wider marketplace means fewer unsold items and less waste for the independent brands we champion.
              </Typography>
            </Box>
            </Box>




            {/* End of four boxes */}

          </Grid>
      </Container>

      {/* Third section */}
      <Container maxWidth='xl' disableGutters sx={{background: "white", px:10, py:5, gap: 5, borderRadius: "0 0 10px 10px"}}>
        <Grid container spacing={0} rowGap={12}>
            {/* Share Row */}
            <Grid item xs={12} md={6} alignItems={"center"} display={"flex"} p={3} justifyContent={"center"}>
                <ShareStockLogo size={450} />
            </Grid>
            <Grid item xs={12} md={1} />

            <Grid item xs={12} md={5} alignItems="center" display="flex">
              <Box alignItems="start" display="flex" flexDirection="column">
                <Typography align="left" variant="h4">
                  Built for
                </Typography>
                <Typography align="left" variant="h4" paragraph>
                  Independent Brands
                </Typography>

                <Typography align="left" variant="body1" paragraph>
We know that running an independent brand is hard. You've put everything into your products — now you need a way to reach the shoppers who will love them, without handing over your store, your customers, or your margins to a middleman.                </Typography>

                <Typography align="left" variant="body1" paragraph width={"100%"}>
                  That's where ShareStock comes in…
                </Typography>

                <Typography align="left" variant="body1" paragraph>
                  ShareStock is a sales channel that connects independent Shopify brands with a nationwide audience of shoppers. You keep your Shopify store, your checkout, your customer relationship — and we help those customers find you.
                </Typography>
              </Box>
            </Grid>

            {/* Testimonial block hidden until new consumer-marketplace testimonials are produced. */}
            {/* The three_testimonials.png asset has retailer/liquidation-era quotes incompatible with the current framing. */}
            {/*
            <Grid item xs={12} alignItems="start" display="flex">
                <Typography align="left" variant="h4">
                  What Our Community is Saying…
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Box
                component="img"
                src={three_testimonials}
                alt="Example Image"
                mb={4}
                sx={{
                  width: "100%",
                  maxWidth: "100%",
                  height: "auto",
                }}
              />
            </Grid>
            */}
            {/* <Grid item xs={12} md={4}>
                <Box
                component="img"
                src={testimonial1}
                alt="Example Image"
                mb={4}
                sx={{
                  width: "100%", // Set width
                  maxWidth: "100%",
                  height: "auto", // Maintain aspect ratio
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
                <Box
                component="img"
                src={testimonial2}
                alt="Example Image"
                mb={4}
                sx={{
                  width: "100%", // Set width
                  maxWidth: "100%",
                  height: "auto", // Maintain aspect ratio
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
                <Box
                component="img"
                src={testimonial3}
                alt="Example Image"
                mb={4}
                sx={{
                  width: "100%", // Set width
                  maxWidth: "100%",
                  height: "auto", // Maintain aspect ratio
                }}
              />
            </Grid> */}
            {!userIsLoggedIn && (

            <Grid item xs={12} alignItems={"center"} display={"flex"} justifyContent={"center"} flexDirection={"column"}>
              <Typography align="center" variant="h4" mb={8}>
                Discover independent brands. Support small businesses. All in one marketplace.
              </Typography>
              <Box display="flex" gap={2}>
                  <Button variant="contained" color="primary" href="/contact">
                    Get More Info
                  </Button>
                  <Button variant="contained" color="secondary" href="/signup">
                    Sign Up
                  </Button>
                </Box>
            </Grid>
            )}

        </Grid>
      </Container>


    </Container>
  );
};

export default LandingPage;
